export default __webpack_public_path__ + "static/media/avatar.04d16163.png";